<template>
  <div>
    <div class="w1200">
      <div class="new-main">
        <div class="news-content">
          <div class="new-l">
            <div class="titleBox" style="margin-bottom: 10px">
              <div class="title">信息动态</div>
              <div class="more" @click="newsMore">查看更多>></div>
            </div>
            <Carousel
              autoplay
              v-model="value2"
              class="planting"
              :autoplay-speed="3000"
            >
              <CarouselItem v-for="item in this.news.right" :key="item.Id">
                <div
                  class="news-item"
                  @click="goNewsDetail(item.Id)"
                  style="cursor: pointer"
                >
                  <img class="newsimg" :src="item.ImgUrl" alt srcset />
                  <div class="jxnewtext">
                    <div class="title">{{ item.Title }}</div>
                    <div class="pubtime">
                      <div>{{ item.PublishTime }}</div>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            </Carousel>
            <div class="new-l-box">
              <div
                class="new-l-list"
                v-for="item in news.left"
                :key="item.Id"
                @click="goNewsDetail(item.Id)"
                style="cursor: pointer"
              >
                <div class="title"><span></span>{{ item.Title }}</div>
                <div class="publishtime">{{ item.PublishTime }}</div>
              </div>
            </div>
          </div>
          <div class="new-left">
            <div class="titleBox">
              <div class="title">通知公告</div>
              <div class="more" @click="goInitiatives">查看更多>></div>
            </div>
            <div
              class="new-list"
              v-for="item in MeasureData"
              :key="item.Id"
              @click="goMeasureDetaill(item.Id)"
            >
              <div class="newsTitle">
                <span class="dot"></span>{{ item.Title }}
              </div>
              <div class="new-time">
                {{ item.PublishTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Quicklink></Quicklink>
      <contactus></contactus>
      <!-- <Link></Link> -->
      <!-- <div class="help">
        <div class="help-list help-list1" @click="helpPage()">
          <div class="icon1"></div>
          <p>帮助中心</p>
        </div>
        <div class="line"></div>
        <div class="help-list help-list2" @click="answerPage()">
          <div class="icon2"></div>
          <p>问题答疑</p>
        </div>
      </div> -->
    </div>

    <!-- <div class="box"> -->
    <!-- <div class="leftfexd">
      <img
        style="width: 230px"
        src="../assets/img/imptz.png"
        alt=""
        srcset=""
      />
      <div class="text-content">
        <div class="title">{{ ZhongYao.Title }}</div>
        <div class="text">{{ ZhongYao.Content }}</div>
      </div>
    </div>
    </div> -->
    <floatView ref="showView" v-if="showView" :json="json" @closeView="closeView"></floatView>
  </div>
</template>
<style lang="less">
@import url("./../assets/css/main.less");
</style>
<script>
import { getNewsHomeData } from "@/api/news";
import { getMeasureHomeData } from "@/api/measure";
import Quicklink from "../components/quicklink";
import Link from "../components/link";
import Query from "../components/query";
import floatView from "../components/floatlayer";
import OrganInfo from "../components/organInfo";
import contactus from "../components/contactus";
export default {
  components: {
    Quicklink,
    Link,
    Query,
    floatView,
    OrganInfo,
    contactus,
  },
  data() {
    return {
      value2: 0,
      ZhongYao: {
        Title: "",
        Content: "",
      },
      news: {
        left: [],
        right: [],
      },
      MeasureData: [],
      json: {
        left: 100,
        top: 400,
        directionX: 1,
        directionY: 1,
        distance: null,
        interval: null,
        target: null,
        zIndex: 9999,
        width: null,
        height: null,
        noHoverPause: null, //鼠标经过时不停止，为true时不停止
        cursor: null,
      },
      showView: false,
    };
  },
  methods: {
    TongGuoList() {
      window.open("http://jxedu.zhujianpeixun.com/", "_blank");
    },
    newsMore() {
      // this.$router.push({ path: '/news', query: { }})
      this.$router.push({ path: "/news", query: {} });
      this.showView = false;
      // window.scrollTo(0, 0);
      // window.open(detail.href, "_blank");
    },

    goInitiatives() {
      this.$router.push({ path: "/initiatives", query: {} });
      this.showView = false;
      // window.scrollTo(0, 0);
    },
    //新闻数据
    getNewsData() {
      var _this = this;
      getNewsHomeData().then((res) => {
        if (res.success) {
          _this.news.right = res.data.slice(0, 3);
          _this.news.left = res.data.slice(3, 6);
        }
      });
    },

    //通知公告
    getMeasureData() {
      var _this = this;
      getMeasureHomeData().then((res) => {
        if (res.success) {
          _this.MeasureData = res.data.slice(0, 7);
        }
      });
    },
    closeView(val) {
      this.showView = false;
    },
    goNewsDetail(id) {
      // this.$router.push({ path: '/newsdetail', query: { 'id': id }})
      this.$router.push({
        path: "/newsdetail",
        query: { id: id },
      });
      this.showView = false;
      // window.scrollTo(0);
    },
    goMeasureDetaill(id) {
      this.$router.push({
        path: "/initiativesdetail",
        query: { id: id },
      });
      this.showView = false;
      // window.scrollTo(0);
    },

    helpPage() {
      this.$router.push({
        path: "/help",
      });
    },
    answerPage() {
      this.$router.push({
        path: "/answer",
      });
    },
  },
  mounted() {
    this.getNewsData();
    this.getMeasureData();
    
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/index.vue